import React, { useEffect, useRef } from 'react';
import AdService from './AdService';

/**
 * GoogleAdUnit - renders a real Google AdSense ad slot.
 * Requires REACT_APP_ADSENSE_SLOT_<NAME> env vars set in Vercel after
 * you create "Ad units" in your AdSense dashboard (Ads -> By ad unit).
 *
 * Usage: <GoogleAdUnit slot="HOMEPAGE_BANNER" isPaidUser={false} format="horizontal" />
 *
 * Until approval + a real slot ID exists, this renders nothing (no broken boxes).
 */
export default function GoogleAdUnit({ slot, isPaidUser = false, format = 'auto', style = {} }) {
  const insRef = useRef(null);
  const pushed = useRef(false);

  const slotId = process.env[`REACT_APP_ADSENSE_SLOT_${slot}`];
  const clientId = process.env.REACT_APP_ADSENSE_CLIENT_ID;

  useEffect(() => {
    if (!slotId || !clientId) return; // not configured yet - render nothing
    if (!AdService.shouldShowAds(isPaidUser)) return;
    if (pushed.current) return;

    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      pushed.current = true;
    } catch (e) {
      console.warn('[GoogleAdUnit] AdSense push failed:', e.message);
    }
  }, [slotId, clientId, isPaidUser]);

  if (!slotId || !clientId) return null;
  if (!AdService.shouldShowAds(isPaidUser)) return null;

  return (
    <div style={{ margin: '8px 28px', textAlign: 'center', ...style }}>
      <ins
        ref={insRef}
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={clientId}
        data-ad-slot={slotId}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </div>
  );
}
